import { useEffect, useRef } from 'react';
import { useActiveWorkspaceName } from '@shared/hooks';
import { useSendPostSignUpMutation } from '@onboarding';
import { LLM_APPLICATION_URL } from '@shared/constants';

const RedirectToLLMAfterSignUp = () => {
  const activeWorkspaceName = useActiveWorkspaceName();
  const requestSentRef = useRef(false);

  const sendPostSignUpFormMutation = useSendPostSignUpMutation();

  useEffect(() => {
    const updateUserStatus = () => {
      if (!requestSentRef.current && activeWorkspaceName) {
        requestSentRef.current = true;

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        sendPostSignUpFormMutation.mutate({
          role: '',
          sizeOfTeam: '',
          modellingArea: ''
        });

        window.location.href = `${LLM_APPLICATION_URL}${activeWorkspaceName}/get-started`;
      }
    };

    updateUserStatus();
  }, [activeWorkspaceName]);

  return null;
};

export default RedirectToLLMAfterSignUp;
